import dayjs from 'dayjs';

export function formatDate(value?: string | number | Date | dayjs.Dayjs | null | undefined) {
    const date = dayjs(value || new Date());
    return date.format('YYYY-MM-DD HH:mm:ss');
}
